// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
var crashWith = function (dictPartial) {
    return $foreign["_crashWith"];
};
var crash = function (dictPartial) {
    return crashWith()("Partial.crash: partial function");
};
export {
    crash,
    crashWith
};
//# sourceMappingURL=index.js.map
